import { render, staticRenderFns } from "./ProgressFooter.vue?vue&type=template&id=b24feda0&scoped=true&"
import script from "./ProgressFooter.vue?vue&type=script&lang=js&"
export * from "./ProgressFooter.vue?vue&type=script&lang=js&"
import style0 from "./ProgressFooter.vue?vue&type=style&index=0&id=b24feda0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24feda0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
